const WIDTH = 520;
const FALLBACK_HEIGHT = 760;

interface ICallPopupFrame {
  width: number;
  height: number;
  top?: number;
}

const availableScreen = (): { height: number; top: number } | null => {
  const screen = window.screen as (Screen & { availTop?: number }) | undefined;
  const height = screen?.availHeight;
  if (typeof height !== 'number' || !Number.isFinite(height) || height <= 0) return null;
  const top = screen?.availTop;
  return {
    height: Math.round(height),
    top: typeof top === 'number' && Number.isFinite(top) ? Math.round(top) : 0,
  };
};

const callPopupFrame = (): ICallPopupFrame => {
  const available = availableScreen();
  if (!available) return { width: WIDTH, height: FALLBACK_HEIGHT };
  return { width: WIDTH, height: available.height, top: available.top };
};

export const callPopupFeatures = (): string => {
  const { width, height, top } = callPopupFrame();
  const position = top === undefined ? '' : `,top=${top}`;
  return `popup=yes,width=${width},height=${height}${position},menubar=no,toolbar=no,location=no,status=no,resizable=yes`;
};

export const fitCallPopupToScreen = (popup: Window | null): boolean => {
  const available = availableScreen();
  if (!popup || !available) return false;
  try {
    popup.moveTo(popup.screenX, available.top);
    popup.resizeTo(popup.outerWidth, available.height);
    return true;
  } catch {
    return false;
  }
};
